
import App from './App'


const store = {
    App,
};

export default store;
